
import Vue, { CreateElement } from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class SmartHeadline extends Vue {
    @Prop({
        type: Boolean,
        default: false
    })
    styleAsH1!: boolean;

    @Prop({ required: false, type: String, default: 'h2', validator: (value: string) => ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(value) })
    level!: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

    render(h: CreateElement) {
        const data = {
            ...this.$props,
            class: {
                h1: this.styleAsH1
            }
        };
        return h(this.level, data, this.$slots.default);
    }
}
